import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_APP002_Request,
  IAPI_APP002_Response,
  IAPI_APP017_Request,
  IAPI_APP017_Response,
} from "../../../type/apiType";

/**
 * 法人ホーム表示
 * @return httpAPI_APP017
 */
const httpAPI_APP017 = async (
  param: IAPI_APP017_Request
): Promise<IAPI_APP017_Response> => {
  const res = await http.post(ApiUrl.API_APP017, {
    ...param,
  });

  return res.data;
};

/**
 * 手続履歴状態更新API
 * @return httpAPI_APP002
 */
const httpAPI_APP002 = async (
  param: IAPI_APP002_Request
): Promise<IAPI_APP002_Response> => {
  const res = await http.post(ApiUrl.API_APP002, {
    ...param,
  });

  return res.data;
};

export { httpAPI_APP017, httpAPI_APP002 };
